<div class="form-group-button text-center">
  <button [disabled]="disabled" (click)="downloadTemplate()" disableRipple mat-button>
    Download CSV template
    <mat-icon>download</mat-icon>
  </button>
</div>
